export default "__VITE_ASSET__cc511fc9__"